import { useAlova } from '@/composables/use-alova'
import { log } from '@/services/log'

export default async function ({ meta: { uri, storeFn }, query: { q: uuid, sourceId } }) {
  if (!uri || !storeFn) return true
  if (uuid != null || sourceId != null) {
    const store = storeFn()
    const path = `/${uri}?q=${uuid === 'new' && sourceId != null ? sourceId : uuid}`
    const api = useAlova().json
    let response
    if (sourceId !== undefined || uuid !== 'new') {
      response = await api.Get(path)
    }
    if (response?.success) {
      const item = response?.result ?? {}
      store.form.item = uuid === 'new' ? store.copy(item) : store.transform(item)
      store.form.beingCopied = sourceId != null
      log(
        'In Load Data For Mono Route Guard URI',
        uri,
        'Request Path',
        path,
        'Response',
        response,
        'Item',
        item,
        'Being Copied',
        sourceId != null
      )
      return true
    } else {
      const item = {}
      store.form.item = uuid === 'new' ? store.copy(item) : store.transform(item)
      store.form.beingCopied = sourceId != null
      log(
        'In Load Data For Mono Route Guard URI',
        uri,
        'Request Path',
        path,
        'Response',
        response,
        'Could not load a valid instance and so navigation is cancelled'
      )
      return true
    }
  }
}
